export default __webpack_public_path__ + "static/media/add_circle_outlined.d3572442.svg";